<template>
  <main class="main main--has-floating-buttons">
    <portal to="headerTitle">
      {{ $t('admin.interfaces.pageFiskaltrustDE.title') }}
    </portal>
    <template v-if="config !== null">
      <spinner-overlay v-if="creationInProgress" />
      <card :title="$t('admin.interfaces.pageFiskaltrustDE.card.general')" cols="12 6@desktop" rows="1">
        <hm-card-inner v-if="!isEmpty(folios)">
          <hm-col cols="12">
            <span class="warning-text col-12">Bitte schließen Sie erst die offenen Geschäftsfälle ab, bevor Sie die TSE aktivieren.</span>
            <hm-button class="btn--green"
                       icon-left="eye"
                       @click="$router.push({ name: 'enableKassenSichV' })">
              Zu den offenen Geschäftsfällen
            </hm-button>
          </hm-col>
        </hm-card-inner>
        <hm-card-inner>
          <hm-input v-model="config.status"
                    :disabled="true"
                    label="Rollout Status"
                    name="status"
                    cols="12 6@hd start-1" />
        </hm-card-inner>
        <hm-card-inner :full-size="true">
          <hm-col cols="12">
            <span class="info-text info-text--full-size info-text--no-margin col-12">Diese Daten sind zwingend erforderlich um eine neue Fiskaly-TSE zu erstellen und mit der Fiskaltrust Middleware zu verknüpfen.</span>
          </hm-col>
        </hm-card-inner>
        <hm-card-inner title="Rollout Einstellungen">
          <hm-input v-model="config.ftAccountId"
                    :disabled="!hasRole('ROLE_SYSADMIN') || !['Draft','TssCreated','TssInitialized'].includes(config.status)"
                    label="Fiskaltrust Account ID"
                    name="ftAccountId"
                    cols="12 6@hd start-1"/>
          <hm-input v-model="config.ftAccessToken"
                    :disabled="!hasRole('ROLE_SYSADMIN') || !['Draft','TssCreated','TssInitialized'].includes(config.status)"
                    label="Fiskaltrust Access Token"
                    name="ftAccessToken"
                    cols="12 6@hd start-1"/>
          <hm-input v-model="config.ftOutletId"
                    :disabled="!hasRole('ROLE_SYSADMIN') || !['Draft','TssCreated','TssInitialized'].includes(config.status)"
                    label="Fiskaltrust Outlet ID"
                    name="ftOutletId"
                    cols="12 6@hd start-1"/>
        </hm-card-inner>
        <hm-card-inner>
          <hm-input v-if="hasRole('ROLE_SYSADMIN')"
                    v-model="config.fiskalyApiKey"
                    :disabled="!hasRole('ROLE_SYSADMIN') || config.status !== 'Draft'"
                    help="Fiskaly API-Key ist nur erforderlich, wenn ein eigenes Fiskaly-Konto verwendet werden soll."
                    label="Fiskaly API Key"
                    name="fiskalyApiKey"
                    cols="12 6@hd start-1"/>
          <hm-input v-if="hasRole('ROLE_SYSADMIN')"
                    v-model="config.fiskalyApiSecret"
                    :disabled="!hasRole('ROLE_SYSADMIN') || config.status !== 'Draft'"
                    help="Fiskaly API-Secret ist nur erforderlich, wenn ein eigenes Fiskaly-Konto verwendet werden soll."
                    label="Fiskaly API Secret"
                    name="fiskalyApiSecret"
                    cols="12 6@hd start-1"/>
        </hm-card-inner>
        <hm-card-inner v-if="hasRole('ROLE_ADMIN')" title="Fiskaly TSE-Einstellungen">
          <hm-input v-model="config.fiskalyTssId"
                    :disabled="!hasRole('ROLE_HOTELMEISTER_SUPER_ADMIN') || config.status !== 'Draft'"
                    label="Fiskaly TSE ID"
                    name="fiskalyTssId"
                    cols="12 6@hd start-1" />
          <hm-input v-model="config.fiskalyAdminPUK"
                    :disabled="!hasRole('ROLE_HOTELMEISTER_SUPER_ADMIN') || config.status !== 'Draft'"
                    label="Fiskaly TSE Admin PUK"
                    name="fiskalyAdminPUK"
                    cols="12 6@hd start-1" />
          <hm-input v-model="config.fiskalyAdminPIN"
                    :disabled="!hasRole('ROLE_HOTELMEISTER_SUPER_ADMIN') || config.status !== 'Draft'"
                    label="Fiskaly TSE Admin PIN"
                    name="fiskalyAdminPIN"
                    cols="12 6@hd start-1" />
        </hm-card-inner>
      </card>
      <card title="CashBox Einstellungen" cols="12 6@desktop">
        <hm-card-inner :full-size="true">
          <hm-col cols="12">
            <span class="info-text info-text--full-size info-text--no-margin col-12">Diesen Abschnitt bitte <b>NUR</b> ausfüllen, wenn eine bestehende (<u>noch nicht intialisierte</u>) Cashbox im Fiskaltrust verbunden werden soll.</span>
          </hm-col>
        </hm-card-inner>
        <hm-card-inner>
          <hm-input-toggle :label="$t('admin.interfaces.pageFiskaltrustDE.enabled')"
                           :enabled-title="$t('enabled')"
                           :disabled-title="$t('disabled')"
                           :disabled="!hasRole('ROLE_SYSADMIN') || isEmpty(config.cashBoxId) || isEmpty(config.accessToken) || isEmpty(config.queueId)"
                           v-model="config.enabled"
                           cols="12 6@hd start-1"
                           name="enabled" />
          <hm-input v-model="config.cashBoxId"
                    :disabled="!hasRole('ROLE_SYSADMIN')"
                    label="Fiskaltrust CashBoxId"
                    name="cashBoxId"
                    cols="12 6@hd start-1"/>
          <hm-input v-model="config.accessToken"
                    :disabled="!hasRole('ROLE_SYSADMIN')"
                    label="Fiskaltrust CashBox AccessToken"
                    name="accessToken"
                    cols="12 6@hd start-1" />
          <hm-input v-model="config.queueId"
                    :disabled="!hasRole('ROLE_SYSADMIN')"
                    label="Fiskaltrust CashBox QueueId (CashBoxIdentification)"
                    name="queueId"
                    cols="12 6@hd start-1" />
        </hm-card-inner>
        <hm-card-inner v-if="hasRole('ROLE_HOTELMEISTER_SUPER_ADMIN')" title="Zusatzeinstellungen (optional) 🔒">
          <hm-input v-model="config.posSystemId" label="PosSystemId" name="posSystemId" cols="12 6@hd start-1" />
          <hm-input v-model="config.baseURL" label="Basis URL" name="baseURL" cols="12 6@hd start-1" />
        </hm-card-inner>
      </card>
      <hm-floating-buttons>
        <hm-floating-button v-if="hasRole('ROLE_SYSADMIN') && config.status != 'StartReceiptCreated'"
                            :throttle="15000"
                            :disabled="isEmpty(config.ftAccessToken) || isEmpty(config.ftAccountId) || isEmpty(config.ftOutletId)"
                            label="Rollout bestehende TSE (Fiskaltrust Sorglos Bundle)"
                            icon="save"
                            color="orange"
                            @click="performRolloutExistingTSE" />
        <hm-floating-button v-if="hasRole('ROLE_SYSADMIN') && config.status != 'StartReceiptCreated'"
                            :throttle="15000"
                            :disabled="isEmpty(config.ftAccessToken) || isEmpty(config.ftAccountId) || isEmpty(config.ftOutletId)"
                            label="Rollout (KOSTENPFLICHTIG!)"
                            icon="save"
                            color="orange"
                            @click="performRollout" />
      </hm-floating-buttons>
    </template>
  </main>
</template>

<script>
/* eslint func-names: 0 */

import HotelmeisterMixin from '@/mixins/HotelmeisterMixin';
import vue2Dropzone from 'vue2-dropzone';
import draggable from 'vuedraggable';
import { cloneDeep, first, groupBy, isEmpty, isNil, sortBy } from 'lodash';
import SaveWatchMixin from '@/mixins/SaveWatchMixin';
import Card from '../../../lib/layout/Card';
import HmInputCheckbox from '../../../lib/inputs/HmInputCheckbox';
import HmInputMoney from '../../../lib/inputs/HmInputMoney';
import HmCardInner from '../../../lib/layout/HmCardInner';
import HmInputNumber from '../../../lib/inputs/HmInputNumber';
import TimerMixin from '../../../../mixins/TimerMixin';
import HmButton from '../../../lib/buttons/HmButton';

export default {
  name: 'PageFiskaltrustDE',
  components: { HmButton, HmInputNumber, HmCardInner, HmInputMoney, HmInputCheckbox, Card },

  filters: {
  },

  mixins: [HotelmeisterMixin, SaveWatchMixin, TimerMixin],

  autosave: [
    {
      name: 'config',
      variable: 'config',
      fn: function (cbSaveComplete) {
        this.axios.put(this.serviceUrls.interfaces.fiskaltrustDE.config(this), this.config)
          .then((response) => {
            this.showMessages(response);
            cbSaveComplete();
          })
          .catch((error) => {
            if (isNil(error.response)) this.showErrorMessage();
            this.showMessages(error.response);
            cbSaveComplete();
          });
      },
    },
  ],

  data() {
    return {
      config: null,
      creationInProgress: false,
      folios: null,
    };
  },

  computed: {
    enums: function () {
      return this.$store.getters['enums/enums'];
    },
  },

  watch: {
    creationInProgress: function (newValue) {
      if (newValue === true) {
        this.as__pauseAutosave('config');
      }
      if (newValue === false) {
        this.updateConfig().then(() => {
          this.as__continueAutosave('config');
        });
      }
    },
  },

  created: function () {
    this.loadData();
  },

  updated() {
  },

  beforeDestroy() {
  },

  methods: {
    loadData() {
      this.updateConfig();
      this.updateFolios();
    },
    updateConfig() {
      return this.axios.get(this.serviceUrls.interfaces.fiskaltrustDE.config(this, null))
        .then((response) => {
          this.config = response.data.data;
        });
    },
    updateFolios() {
      return this.axios.get(this.serviceUrls.report.data(this, '5953f9c5-a8a0-41cb-a456-511eb2adaab9'))
        .then((response) => {
          this.folios = response.data.data;
        })
        .catch(() => {
          this.folios = [];
        });
    },
    performRollout() {
      this.creationInProgress = true;
      this.axios.get(this.serviceUrls.report.data(this, '5953f9c5-a8a0-41cb-a456-511eb2adaab9'))
        .then((response) => {
          const folios = response.data.data;
          if (isEmpty(folios)) {
            this._confirmRollout();
          } else {
            this.showErrorMessage('Bitte schließen die offenen Geschäftsfälle ab, bevor Sie die TSE aktivieren.');
            this.creationInProgress = false;
          }
        })
        .catch(() => {
          this.creationInProgress = false;
        });
    },
    performRolloutExistingTSE() {
      this.creationInProgress = true;
      this.axios.get(this.serviceUrls.report.data(this, '5953f9c5-a8a0-41cb-a456-511eb2adaab9'))
        .then((response) => {
          const folios = response.data.data;
          if (isEmpty(folios)) {
            this._confirmRolloutExistingTSE();
          } else {
            this.showErrorMessage('Bitte schließen die offenen Geschäftsfälle ab, bevor Sie die TSE aktivieren.');
            this.creationInProgress = false;
          }
        })
        .catch(() => {
          this.creationInProgress = false;
        });
    },
    _confirmRollout() {
      this.showConfirmModal(
        'Sind Sie sicher, dass Sie <b>KOSTENPFLICHTIG</b> eine Fiskaly-TSE für diesen Betrieb erstellen möchten? Diese Operation kann <b>nicht</b> mehr rückgängig gemacht werden.',
        this._rollout,
        'Bitte stellen Sie sicher, dass keine andere Person mit der Hotelsoftware, für diesen Betrieb arbeitet, während diese TSE in Betrieb genommen wird.',
        {
          button1: {
            onClick: () => {
              this.creationInProgress = false;
            },
          },
        },
      );
    },
    _confirmRolloutExistingTSE() {
      this.showConfirmModal(
        'Sind Sie sicher, dass Sie eine Kasse für eine BESTEHENDE Fiskaly TSE (z.B. aus dem Fiskaltrust Sorglos-Bundle) erstellen möchten? Diese Operation kann <b>nicht</b> mehr rückgängig gemacht werden. Bitte beachten Sie, dass die TSE im angegebenen Fiskaltrust-Konto und Standort bereits vorhanden sein muss und noch mit keiner Queue verbunden sein darf.',
        this._rolloutExistingTSE,
        'Bitte stellen Sie sicher, dass keine andere Person mit der Hotelsoftware, für diesen Betrieb arbeitet, während diese TSE in Betrieb genommen wird.',
        {
          button1: {
            onClick: () => {
              this.creationInProgress = false;
            },
          },
        },
      );
    },
    _rollout() {
      this.axios.post(this.serviceUrls.interfaces.fiskaltrustDE.rollout(this), {})
        .then((response) => {
          this.updateConfig();
          this.showConfirmModal(
            'Die TSE wurde erfolgreich erstellt, bitte erfassen Sie JETZT den Anfangsbestand.',
            () => {
              this.$router.push({ name: 'enableKassenSichV' });
            },
          );
        })
        .catch((error) => {
          this.showMessages(error.response);
          this.showErrorMessage('');
        })
        .finally(() => {
          this.updateConfig().then(() => {
            this.creationInProgress = false;
          });
        });
    },
    _rolloutExistingTSE() {
      this.axios.post(this.serviceUrls.interfaces.fiskaltrustDE.rolloutExistingTSE(this), {})
        .then((response) => {
          this.updateConfig();
          this.showConfirmModal(
            'Die TSE wurde erfolgreich erstellt, bitte erfassen Sie JETZT den Anfangsbestand.',
            () => {
              this.$router.push({ name: 'enableKassenSichV' });
            },
          );
        })
        .catch((error) => {
          this.showMessages(error.response);
          this.showErrorMessage('');
        })
        .finally(() => {
          this.updateConfig().then(() => {
            this.creationInProgress = false;
          });
        });
    },
  },
};
</script>

<!-- Scoped SCSS  -->
<style lang="scss" scoped>
@import '~styles/import';

.hm-table__td {
  &--selected {
    &:before {
      content: ' ';
      left: 0;
      right: 0;
      background: $lightgray;
      height: 4.8rem;
      position: absolute;
      z-index: -1;
    }
  }
  &--icon {
    display: flex;
    flex-direction: column;

    .hm-icon {
      display: flex;
      flex-direction: column;
      flex: 1;
      justify-content: center;
      width: 100%;
      height: 100%;
    }

    @include icon-color($mint);
  }
}
</style>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/pages/admin/interfaces/PageFiskaltrustDE.vue